
export const environment = {
  general: {
    production: false,
    product: 'retail',
    title: 'Tienda Buho',
    url: 'https://server.buhomanager.com:444/',
    useMultiClient: false,
    nameMultiClient: 'multibags',
    logoUrl: 'https://buho-images.s3.sa-east-1.amazonaws.com/multiclient/upload/photos-articles/multibag-logo-inv.jpg',
    carouselImages: 0,
    phoneNumber: 3541272452,
    columnsItemMobile: 2,
    validateStock: false
  },
  bucketConfig: {
    region: 'sa-east-1',
    accessKey: '',
    secretAccessKey: '',
    bucketName: 'buho-images',
    bucketFolderToSavePhotos: 'multiclient/upload/photos-articles/',
    bucketFolderToSaveFiles: 'multiclient/upload/files/',
  },
  htmlContent: {
    separator: '<div class="banner-separator"><h3>Consultas</h3><span>Realiza tus consultas por whatsapp</span></div>'
  },
  mercadoPago: {
    useMercadoPago: false,
    MercadoPago_Token_Test: 'TEST-629442988883571-120719-c71ef7ff354c5e05c34e3d1b94fa5941-29175092',
    MercadoPago_Token_Prod: 'TEST-629442988883571-120719-c71ef7ff354c5e05c34e3d1b94fa5941-29175092',
    MercadoPago_Back_Url: 'https://multibags.com'
  },
  shipping: {
    useShipping: false,
  }
};
